import SelectRowCell from '@/backgrid/SelectRowCell';
import PageableCollection from '@/backbone/PageableCollection';
import StringCell from '@/backgrid/StringCell';
import GridView from '@/views/GridView';

const CommandPOCsGrid = GridView.extend({
    options: {
        pageSize: 25
    },

    initialize() {
        this.options.columns = [
            {
                name: 'selected',
                label: '',
                cell: SelectRowCell.SelectRowCell,
                headerCell: SelectRowCell.SelectAllHeaderCell,
                width: 5,
                editable: true,
                sortable: false
            },
            {
                name: 'commandName',
                label: 'Command Name',
                cell: StringCell,
                headerCell: 'custom',
                width: 15,
                editable: true,
                sortable: true
            },
            {
                name: 'pocName',
                label: 'POC Name',
                cell: StringCell,
                headerCell: 'custom',
                width: 15,
                editable: true,
                sortable: true
            },
            {
                name: 'email',
                label: 'Email',
                cell: StringCell,
                headerCell: 'custom',
                width: 15,
                editable: true,
                sortable: true
            },
            {
                name: 'telephone',
                label: 'Telephone',
                cell: StringCell,
                headerCell: 'custom',
                width: 15,
                editable: true,
                sortable: true
            },
            {
                name: 'pocType',
                label: 'POC Type',
                cell: StringCell,
                headerCell: 'custom',
                width: 15,
                editable: true,
                sortable: true
            }
        ];

        this.collection = new PageableCollection(this.model.get('commandPOCs'), {
            pageSize: 8
        });
        this.options.emptyText = 'No Command POCs Found';
        GridView.prototype.initialize?.apply(this, this.options);
    }
});

export default CommandPOCsGrid;
